import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { environment } from '../../environments/environment';
import { SessionService } from './session.service';

@Injectable({
  providedIn: 'root'
})
export class ServiceService {

  constructor(
    private http: HttpClient,
    private sessionService: SessionService
    ) { }
    
  token = this.sessionService.currentUserValue.token;

  getAllServices() {
    return this.http.get<any>(`${environment.apiUrl}/business_service_all/`);
  }

  getServices(city){
    return this.http.get<any>(`${environment.apiUrl}/business_service/?city_id=${city}`);
  }
}
